import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as ls from "./_csLcl";
import { a } from "./_csAbt";

import * as BtnC from './_cccBtnC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";
import * as BoxC from './_ccbBoxC';
import * as GridC from './_cccGridC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

import * as ica from 'src/ica';
import * as ihd from 'src/ihd';

import * as icvI20___Mz from './icvI20___Mz';

let $i20z = icvI20___Mz.itlI20z();

import * as BtnCttC from './_ccmBtnCttC';

/*
export const B = (pz: ht.btnCttCz) => {
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const i20z = await icvI20___Mz.saveI20rDzAsync({
            ... pz,
            i20z: $i20z,
          });
          return {
            i20r_fst: i20z.i20rz._fst,
          };
        }
      }
    })
  );
};
*/
export const B = (pz: ht.btnCttCz) => {
  //hf.l(`icvI20___Ci 51: ${hf.s($i20z)}`)
  return (
    cr.c(BtnCttC.N, {
      key: -20,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _dz = await icvI20___Mz.saveI20rDzAsync({
            ... pz,
            i20z: $i20z,
          });
          return _dz;
        }
      },
      onBackPrs: () => {
        cr.moveTo({
          pageName: 'icvHomeK10Rz',
        });
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz) => {

  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {

    f.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      crtAsync: () => [
        icvI20___Mz.crtI20z()
        .then((_dz: ht.dz) => {
          $i20z = _dz;
        })
      ],
      udtAsync: () => [
        icvI20___Mz.loadI20rDzAsync({ // ドメイン共通のため i20r_fst を指定しない
          //i20r_fst: pz.sPz.crt.i20r_fst
        })
        .then((_dz: ht.dz) => {
          $i20z = _dz;
        })
      ],
    });

  }, [
    pz.sPz.crt.phs,
    //pz.sPz.crt.i20r_fst
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

/*
  const _hdrs = [] as ht.ls;

  _hdrs.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: '祝日',
              stlz: a(`tc/${pz.cz.ccd}7`)
            }
          })
        ]
      },
    ],
  });

//  const _bdys = [] as ht.ls;
*/

  return (
    cr.c(BoxC.N, {
      key: 'i20b.Root',
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/2 mh/a'),
          lineCs: [

            {
              boxStlz: a(`dw/60 f/n mb/2 mh/a`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `ホスト：`,
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i20z.i20rz.i20ra1110s ?? '',
                              onChg: (_s: ht.s) => {
                                $i20z.i20rz.i20ra1110s = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },

            {
              boxStlz: a(`dw/60 f/n mb/2 mh/a`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `ポート：`,
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i20z.i20rz.i20ra1120s ?? '',
                              onChg: (_s: ht.s) => {
                                $i20z.i20rz.i20ra1120s = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },

            {
              boxStlz: a(`dw/60 f/n mb/2 mh/a`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `ユーザ：`,
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i20z.i20rz.i20ra1210s ?? '',
                              onChg: (_s: ht.s) => {
                                $i20z.i20rz.i20ra1210s = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },

            {
              boxStlz: a(`dw/60 f/n mb/2 mh/a`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `パスワード：`,
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i20z.i20rz.i20ra1220s ?? '',
                              onChg: (_s: ht.s) => {
                                $i20z.i20rz.i20ra1220s = _s;
                              },
                              bScr: true
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },

          ]
        }),

/*
        cr.c(TblC.N, {
          key: -20,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/50'),
            }
          },
          hdrCz: {
            boxStlz: a(`bc/${pz.cz.ccd}7`),
            lineCs: _hdrs
          },
          bdyCz: {
            boxStlz: a(`bc/${pz.cz.ccd}7`),
            lineCs: _bdys
          }
        })
*/
      ]
    })
  );
};

